module.exports = __webpack_public_path__ + "img/m-pop-service-end-wavve.93421951.png";